export default {"src":"/pro/_next/static/media/op.1117d870.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};